// extracted by mini-css-extract-plugin
module.exports = {"moreText":"antd-pro-utils-utils-moreText"};